<template>
  <div class="article_apply_box my_container"
  v-loading="load.loading"
  :element-loading-text="load.text"
  element-loading-spinner="el-icon-loading">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>发布文章</span>
        <el-divider></el-divider>
      </p>
    </div>
    <el-form ref="articleForm" method="POST" :model="apply" :rules="rules" label-position="left" label-width="80px" :hide-required-asterisk=hideRequiredAsterisk @submit.prevent="submitForm" :status-icon='true' >
      <el-form-item label="文章标题" prop="article_title">
          <el-input type="text" v-model="apply.article_title" maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="所属板块" prop="nav_id">
        <el-cascader class="el-select"
        v-model = "apply.model_arr"
        :options="modelOptionsList"
        :props="modelProps"
        @change="modelChange">
        </el-cascader>
      </el-form-item>
      <el-form-item label="添加标签" prop="tag_id">
        <el-select
            v-model="apply.tag_id"
            multiple
            filterable
            default-first-option
            :multiple-limit = 5
            placeholder="请选择文章标签">
            <el-option
              v-for="item in labelOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <div class="wangeditor_box">
        <div v-if="conserveShow && conserveWait" class="wangeditor_conserve">
          <i class="el-icon-loading"></i>自动保存中...
        </div>
        <div v-if="conserveShow && !conserveWait" class="wangeditor_conserve">
          已保存
        </div>
        <editor-view
        v-if="fileView && wangEditorOnOff"
        :editorval='apply.article_content'
        @monitor = "monitor">
        </editor-view>
      </div>
      <!-- 专家观点 -->
      <el-form-item v-show="apply.nav_id === 9" label="专家姓名" prop="headimg">
        <el-input type="text" v-model="apply.expert_name"></el-input>
      </el-form-item>
      <el-form-item v-show="apply.nav_id === 9" label="专家头像" prop="headimg">
        <img-view v-if="fileView" :filestype="headImgType" :imgurl="apply.head"  @files = "filesUrl"></img-view>
      </el-form-item>
      <!-- 文章封面 -->
      <el-form-item  v-show="apply.nav_id === 15 || apply.nav_id === 16 || apply.nav_id === 17 || apply.nav_id === 18 || apply.nav_id === 19 || apply.nav_id === 23 || apply.nav_id === 24" label="文章封面" prop="pic">
        <img-view v-if="fileView" :filestype="acticleImgType" :imgurl="apply.pic"  @files = "filesActicleImg"></img-view>
      </el-form-item>
      <!-- 出版物 -->
      <el-form-item v-show="apply.nav_id === 29" label="作者" prop="author"
      :required="apply.nav_id === 29 ? true : false">
        <el-input v-model="apply.author"></el-input>
      </el-form-item>
      <el-form-item v-show="apply.nav_id === 29" label="出版社" prop="press"
      :required="apply.nav_id === 29 ? true : false">
        <el-input v-model="apply.press"></el-input>
      </el-form-item>
      <el-form-item v-show="apply.nav_id === 29" label="封面" prop="headimg">
        <img-view v-if="fileView" :filestype="headImgType" :imgurl="apply.book_img"  @files = "filesBookImg"></img-view>
      </el-form-item>
      <el-form-item label="文章类型" prop="type">
        <el-select v-model="apply.type" placeholder="请选择文章类型">
          <el-option label="请选择" value=""></el-option>
          <el-option label="原创" value="1"></el-option>
          <el-option label="转载" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="apply.type === '2'" label="转载地址" prop="address">
        <el-input v-model="apply.address" placeholder="请填写转载地址或媒体"></el-input>
      </el-form-item>
      <el-form-item
      v-show="apply.nav_id === 20 || apply.nav_id === 21 || apply.nav_id === 22 || apply.nav_id === 27 || apply.nav_id === 28"
      label="附件" prop="files">
        <file-view v-if="fileView" :filestype="filestype" :article-file-list = "fileList" @files = "filesArray"></file-view>
      </el-form-item>
      <el-form-item>
        <div class="rg_form_box_form_item">
          <el-button type="primary" class="my_save" @click="preservedForm('button')">保存</el-button>
          <el-button type="primary" class="my_sub" @click="submitForm('articleForm')">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import fileupload from '../Public/fileUpload.vue'
import imgupload from '../Public/imgUpload.vue'
import editor from '../Public/wangeditor.vue'
export default {
  components: {
    fileView: fileupload,
    imgView: imgupload,
    editorView: editor
  },
  data () {
    return {
      load: {
        loading: false,
        text: '数据加载中...'
      },
      type: '',
      conserveShow: false, // 自动保存显示
      conserveWait: false, // 自动保存状态
      hideRequiredAsterisk: false, // 表单必填项显示红星
      apply: { // 文章提交数据
        article_title: '',
        model_arr: [], // 板块选择绑定值
        nav_id: '',
        union_id: '', // 联盟id
        research_id: '', // 研究院id
        tag_id: '', // 标签id
        article_content: '', // 文本内容带样式
        article_text: '', // 纯文本内容
        head: '', // 专家头像
        drafts_id: '', // 草稿id
        expert_name: '', // 专家姓名
        more: '',
        article_id: '',
        time: [], // 项目路演时间
        book_img: '', // 书籍封面
        author: '', // 作者
        press: '', // 出版社
        pic: '', // 文章封面
        type: '', // 文章类型 1原创 2转载
        address: '' // 转载地址
      },
      pickerOptions0: { // 限制日期
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      modelProps: { // 板块选择器配置
        value: 'id',
        label: 'name',
        children: 'model'
      },
      modelOptionsList: [], // 板块选择数组
      labelOptions: [], // 标签列表
      fileView: true, // 图片、文件显示开关
      wangEditorOnOff: false, // 编辑器开关
      headImgType: 'headImg', // 头像判断属性
      acticleImgType: 'filesArticleImg', // 文章封面判断属性
      filestype: 'files', // 文件判断属性
      fileList: [], // 附件列表
      rules: {
        article_title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        nav_id: [{ required: true, message: '请选择发布文章所属板块', trigger: 'blur' }],
        tag_id: [{ required: true, message: '请选择文章标签', trigger: 'blur' }],
        author: [{ message: '作者不能为空', trigger: 'blur' }],
        press: [{ message: '出版社不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '文章类型不能为空', trigger: 'blur' }],
        address: [
          {
            validator: (rule, value, callback) => {
              if (this.apply.type === '2') {
                if (value === '') {
                  callback(new Error('转载地址不能为空'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          }
        ]
      },
      preservedBtnOnOff: true, // 保存按钮开关
      subBtnOnOff: true // 提交按钮开关
    }
  },
  created () {
    const vueThat = this
    vueThat.apply.drafts_id = vueThat.$route.query.id
    vueThat.apply.article_id = vueThat.$route.query.id
    vueThat.type = vueThat.$route.query.type
    vueThat.getModel()
    vueThat.getLabel()
  },
  methods: {
    // 获取选择模块
    getModel () {
      const vueThat = this
      const typeId = 3
      vueThat.myApi.getModel({ type_id: typeId }).then(function (res) {
        console.log(res)
        if (res.data.code === 200) {
          const navList = res.data.data.nav_list
          const unionList = res.data.data.union_list
          const researchList = res.data.data.research_list
          for (let i = 0; i < navList.length; i++) {
            const model = navList[i].model
            for (let n = 0; n < model.length; n++) {
              const sonModel = model[n].model
              if (sonModel !== undefined && sonModel.length > 0) {
                for (let m = 0; m < sonModel.length; m++) {
                  if (sonModel[m].is_use === 0) {
                    sonModel[m].name += '(暂不支持)'
                    sonModel[m].disabled = true
                  }
                }
              } else {
                if (model[n].is_use === 0) {
                  model[n].name += '(暂不支持)'
                  model[n].disabled = true
                }
              }
            }
          }
          if (unionList.length > 0 && navList[1].model.length > 0) {
            for (let i = 0; i < unionList.length; i++) {
              unionList[i].model = navList[1].model
            }
            navList[1].model = unionList
          } else {
            navList[1].disabled = true
          }
          if (researchList.length > 0 && navList[2].model.length > 0) {
            for (let i = 0; i < researchList.length; i++) {
              researchList[i].model = navList[2].model
            }
            navList[2].model = researchList
          } else {
            navList[2].disabled = true
          }
          vueThat.modelOptionsList = navList
        }
      })
    },
    // 模块选定后的回调
    modelChange (value) {
      if (value.length > 0) {
        if (value[0] === 3) {
          this.apply.union_id = value[1]
          this.apply.nav_id = value[2]
        } else if (value[0] === 4) {
          this.apply.research_id = value[1]
          this.apply.nav_id = value[2]
        } else {
          this.apply.nav_id = value[1]
        }
      }
    },
    // 获取标签
    getLabel () {
      const vueThat = this
      vueThat.myApi.getLabel().then(function (data) {
        if (data.data.code === 200) {
          vueThat.labelOptions = data.data.data
          vueThat.$nextTick(function () {
            if (vueThat.apply.drafts_id !== undefined) {
              if (vueThat.type === 'article') {
                vueThat.myApi.articleEdit({ article_id: vueThat.apply.drafts_id }).then((res) => { vueThat.getInfo(res) })
              } else {
                vueThat.myApi.draftDetail({ article_drafts_id: vueThat.apply.drafts_id }).then((res) => { vueThat.getInfo(res) })
              }
            } else {
              vueThat.fileView = true
              vueThat.wangEditorOnOff = true
              vueThat.load.loading = false
            }
          })
        }
      })
    },
    // 获取信息赋值公用函数
    getInfo: function (res) {
      const vueThat = this
      if (res.data.code === 200) {
        vueThat.load.loading = false
        vueThat.apply.drafts_id = res.data.data.id
        vueThat.apply.article_title = res.data.data.article_title
        vueThat.apply.article_content = res.data.data.article_content
        vueThat.wangEditorOnOff = true
        vueThat.apply.head = res.data.data.head
        vueThat.apply.expert_name = res.data.data.expert_name
        vueThat.apply.book_img = res.data.data.book_img
        vueThat.apply.author = res.data.data.author
        vueThat.apply.press = res.data.data.press
        vueThat.apply.type = res.data.data.type + ''
        vueThat.apply.address = res.data.data.address
        vueThat.apply.pic = res.data.data.pic
        if (res.data.data.nav_id === 0) {
          vueThat.apply.nav_id = ''
        } else {
          vueThat.apply.nav_id = res.data.data.nav_id
        }
        vueThat.apply.model_arr = []
        if (res.data.data.research_id !== 0) {
          vueThat.apply.research_id = res.data.data.research_id
          vueThat.apply.model_arr.push(4, res.data.data.research_id, vueThat.apply.nav_id)
        } else if (res.data.data.union_id !== 0) {
          vueThat.apply.union_id = res.data.data.union_id
          vueThat.apply.model_arr.push(3, res.data.data.union_id, vueThat.apply.nav_id)
        } else {
          vueThat.apply.model_arr.push(2, vueThat.apply.nav_id)
        }
        if (res.data.data.tag_id !== '') {
          vueThat.apply.tag_id = res.data.data.tag_id.split(',')
          for (let i = 0; i < vueThat.apply.tag_id.length; i++) {
            vueThat.apply.tag_id[i] = parseInt(vueThat.apply.tag_id[i])
          }
        }
        if (res.data.data.more === null) {
          vueThat.apply.more = ''
        } else {
          for (let i = 0; i < res.data.data.more.length; i++) {
            const obj = {}
            obj.name = res.data.data.more[i].name
            obj.path = res.data.data.more[i].path
            obj.state = '上传成功'
            vueThat.fileList.push(obj)
          }
        }
        vueThat.fileView = true
        vueThat.load.loading = false
      }
    },
    // 实时监控更新正文内容
    monitor: function (val, text) {
      // 带样式
      this.apply.article_content = val
      // 纯文本
      this.apply.article_text = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
      if (this.type !== 'article') {
        this.preservedForm('monitor')
      }
    },
    // 获取头像文件
    filesUrl: function (data, type) {
      this.apply.head = data
      if (this.type !== 'article') {
        this.preservedForm('monitor')
      }
    },
    // 获取文章封面
    filesActicleImg: function (data, type) {
      this.apply.pic = data
      if (this.type !== 'article') {
        this.preservedForm('monitor')
      }
    },
    // 获取书籍封面
    filesBookImg: function (data, type) {
      this.apply.book_img = data
      if (this.type !== 'article') {
        this.preservedForm('monitor')
      }
    },
    // 获取附件列表
    filesArray: function (data) {
      this.fileList = data
      if (this.type !== 'article') {
        this.preservedForm('monitor')
      }
    },
    // 点击保存
    preservedForm: async function (subType) {
      const vueThat = this
      if (subType === 'monitor') {
        vueThat.conserveShow = true
        vueThat.conserveWait = true
      }
      console.log(vueThat.apply.model_arr)
      const data = JSON.parse(JSON.stringify(vueThat.apply))
      // 标签
      if (vueThat.apply.tag_id !== '') {
        data.tag_id = data.tag_id.join(',')
      }
      // 文件
      if (vueThat.fileList.length > 0) {
        data.more = vueThat.fileList
      }
      await vueThat.myApi.articlesPreserved(data).then(function (res) {
        if (res.data.code === 200) {
          if (subType === 'monitor') {
            vueThat.conserveShow = true
            vueThat.conserveWait = false
          } else {
            vueThat.$confirm('保存草稿成功', '温馨提示', {
              confirmButtonText: '去预览',
              cancelButtonText: '确定'
            }).then(() => {
              vueThat.$router.push({ name: 'ArticleDetail', params: { id: res.data.data } })
            }).catch(() => {
              vueThat.$store.commit('editPersonalMeunAct', 'draftList')
              vueThat.$router.push({ name: 'DraftList' })
            })
          }
          vueThat.apply.drafts_id = res.data.data
        }
      }).catch(function () {})
    },
    // 点击提交
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        console.log(vueThat.apply)
        if (valid) {
          vueThat.load.loading = true
          vueThat.load.text = '数据提交中，请勿关闭页面...'
          try {
            const data = JSON.parse(JSON.stringify(vueThat.apply))
            data.tag_id = data.tag_id.join(',')
            // 如果有附件
            if (vueThat.fileList.length > 0) {
              data.more = vueThat.fileList
            }
            if (data.article_content === '') {
              vueThat.$alert('未填写正文内容', '温馨提示', {
                confirmButtonText: '确定',
                callback: () => {
                  vueThat.load.loading = false
                }
              })
            } else {
              switch (data.nav_id) {
                case 9:
                  if (data.head === '') {
                    vueThat.$alert('请上传专家头像', '温馨提示', {
                      confirmButtonText: '确定',
                      callback: () => {
                        vueThat.load.loading = false
                        vueThat.subBtnOnOff = true
                      }
                    })
                  } else if (data.expert_name === '') {
                    vueThat.$alert('请输入专家姓名', '温馨提示', {
                      confirmButtonText: '确定',
                      callback: () => {
                        vueThat.load.loading = false
                        vueThat.subBtnOnOff = true
                      }
                    })
                  } else {
                    vueThat.subInterface(data)
                  }
                  break
                case 29:
                  if (data.book_img === '') {
                    vueThat.$alert('请上传书籍封面', '温馨提示', {
                      confirmButtonText: '确定',
                      callback: () => {
                        vueThat.load.loading = false
                      }
                    })
                  } else {
                    vueThat.subInterface(data)
                  }
                  break
                default:
                  vueThat.subInterface(data)
              }
            }
          } catch (e) {
            console.log('报错')
          }
        } else {
          return false
        }
      })
    },
    // 提交函数
    subInterface (data) {
      const vueThat = this
      if (this.type === 'article') {
        vueThat.myApi.articleEditSub(data)
          .then(function (res) {
            vueThat.subLayer(res)
          })
      } else {
        vueThat.myApi.articlesSub(data)
          .then(function (res) {
            vueThat.subLayer(res)
          })
      }
    },
    // 提交弹窗
    subLayer (res) {
      const vueThat = this
      if (res.data.code === 200) {
        vueThat.$alert('提交申请成功，请耐心等待审核通过', '温馨提示', {
          type: 'success',
          iconClass: 'iconfont icon-icon_richeng_btn_pass',
          confirmButtonText: '确定',
          showClose: false,
          callback: action => {
            vueThat.$store.commit('editPersonalMeunAct', 'articleList')
            vueThat.$router.push({ name: 'ArticleList' })
          }
        })
      } else {
        vueThat.load.loading = false
      }
    }
  }
}
</script>

<style>
</style>
